"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orchestrator = void 0;
var Orchestrator = /** @class */ (function () {
    function Orchestrator() {
        this.commands = {};
        this.subscribers = {};
        this.queries = {};
    }
    Orchestrator.prototype.addQueries = function (newQueries) {
        this.queries = __assign(__assign({}, this.queries), newQueries);
    };
    Orchestrator.prototype.addCommands = function (newCommands) {
        this.commands = __assign(__assign({}, this.commands), newCommands);
    };
    Orchestrator.prototype.runCommand = function (name, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var command;
            return __generator(this, function (_a) {
                command = this.commands[name];
                if (!command)
                    throw new Error("Orchestrator_CommandNotFound: ".concat(name));
                return [2 /*return*/, command(payload)];
            });
        });
    };
    Orchestrator.prototype.runQuery = function (name, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var query;
            return __generator(this, function (_a) {
                query = this.queries[name];
                if (!query)
                    throw new Error("Orchestrator_QueryNotFound: ".concat(name));
                return [2 /*return*/, query(payload)];
            });
        });
    };
    Orchestrator.prototype.on = function (name, handler) {
        var _this = this;
        var _a;
        var currentHandlers = (_a = this.subscribers[name]) !== null && _a !== void 0 ? _a : [];
        this.subscribers[name] = __spreadArray(__spreadArray([], currentHandlers, true), [handler], false);
        return function () { return _this.off(name, handler); };
    };
    Orchestrator.prototype.off = function (name, handler) {
        var _a;
        var currentHandlers = (_a = this.subscribers[name]) !== null && _a !== void 0 ? _a : [];
        this.subscribers[name] = currentHandlers.filter(function (item) { return item !== handler; });
    };
    Orchestrator.prototype.publish = function (name, payload) {
        if (this.subscribers[name] && this.subscribers[name].length) {
            this.subscribers[name].forEach(function (listener) { return listener(payload); });
        }
    };
    return Orchestrator;
}());
exports.Orchestrator = Orchestrator;
